import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";
import { callEdgeApi } from "@/lib/edge-api";

const itemSchema = z.object({
  slug: z.string().min(1).max(120),
  name: z.string().min(1).max(200),
});

const inputSchema = z
  .object({
    nome: z.string().trim().min(1, "Nome obbligatorio").max(80),
    cognome: z.string().trim().min(1, "Cognome obbligatorio").max(80),
    telefono: z
      .string()
      .trim()
      .min(6, "Telefono non valido")
      .max(30)
      .regex(/^[+0-9\s().-]+$/, "Telefono non valido"),
    email: z
      .string()
      .trim()
      .max(200)
      .email("Email non valida")
      .optional()
      .or(z.literal("").transform(() => undefined)),
    note: z.string().trim().max(1000).optional().or(z.literal("").transform(() => undefined)),
    dataRitiro: z.string().min(4).max(40), // ISO date (YYYY-MM-DD)
    items: z.array(itemSchema).min(1, "Il carrello è vuoto"),
  })
  .refine(
    (v) => {
      const d = new Date(v.dataRitiro + "T12:00:00");
      if (Number.isNaN(d.getTime())) return false;
      const tomorrow = new Date();
      tomorrow.setHours(0, 0, 0, 0);
      tomorrow.setDate(tomorrow.getDate() + 1);
      return d >= tomorrow;
    },
    { message: "La data richiesta deve essere almeno domani", path: ["dataRitiro"] },
  );

export const submitRichiesta = createServerFn({ method: "POST" })
  .inputValidator((i) => inputSchema.parse(i))
  .handler(async ({ data }): Promise<{ ok: true; id: string; telegramSent: boolean }> => {
    const res = await callEdgeApi<{ ok: true; id: string; telegramSent: boolean }>("submit_richiesta", data);
    return res;
  });